/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const model = "/models/desk/keyboard.glb";

export default function Keyboard({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-2.27, 1.04, 2.52]}>
        <mesh
          geometry={nodes.Plane003.geometry}
          material={materials["black mate.002"]}
        />
        <mesh
          geometry={nodes.Plane003_1.geometry}
          material={materials["black mate"]}
        />
        <mesh
          geometry={nodes.Plane003_2.geometry}
          material={materials["black mate.001"]}
        />
        <mesh
          geometry={nodes.Plane003_3.geometry}
          material={materials["black mate.003"]}
        />
        <mesh
          geometry={nodes.Plane003_4.geometry}
          material={materials["black mate.004"]}
        />
        <mesh
          geometry={nodes.Plane003_5.geometry}
          material={materials["black mate.005"]}
        />
        <mesh
          geometry={nodes.Plane003_6.geometry}
          material={materials["black mate.006"]}
        />
        <mesh
          geometry={nodes.Plane003_7.geometry}
          material={materials["black mate.007"]}
        />
        <mesh
          geometry={nodes.Plane003_8.geometry}
          material={materials["black mate.008"]}
        />
        <mesh
          geometry={nodes.Plane003_9.geometry}
          material={materials["black mate.009"]}
        />
        <mesh
          geometry={nodes.Plane003_10.geometry}
          material={materials["black mate.010"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
